import * as actionTypes from './actionTypes';

export const getWorks = (fulltext = "", search = [], limit = 20, offset = 0, sort = {}) => {
    
    const add = {};
    
    if(search.fields && search.fields.length) {
        add.fields = search.fields;
    } else {
        add.fields = [];
    }
    
    add.fields.push({ field: sort.field, type: "ORDER", value: sort.dir});
    
    add.limit = limit;
    add.offset = offset;
    
    return (dispatch) => {
        dispatch({ type: actionTypes.SDK_WORK_GET_START });
        window.flow.sdkSearchWerke(fulltext, add).then((res) => {
            console.log(res);
            dispatch({ type: actionTypes.SDK_WORK_GET_SUCCESS, works: res.objects.asArray(), count: res.count || 0 });
        }).catch(res => {
            dispatch({ type: actionTypes.SDK_WORK_GET_FAIL });
        });
    };
};

export const getWork = (id = 1) => {
    console.log(id);
    return (dispatch) => {
        dispatch({ type: actionTypes.SDK_WORK_GET_START });
        window.flow.sdkGetWerk(id).then((res) => {
            console.log(res);
            dispatch({ type: actionTypes.SDK_WORK_GET_ONE_SUCCESS, work: res/*.children[0]*/, id: id });
        }).catch(res => {
            dispatch({ type: actionTypes.SDK_WORK_GET_FAIL });
        });
    };
};

export const getWorkAll = () => {
    return dispatch => {
        dispatch({ type: actionTypes.SDK_WORK_GET_START });

        /* TODO: VARIABLES FOR DISTRIBUTION TREE */
        window.flow.getDistprojectsForDist('sdk_werk', 0).then(res => {
            //dispatch(getDistributionByDistSuccess(res.distproject.elements));
        }).catch(res => {
            dispatch({ type: actionTypes.SDK_WORK_GET_FAIL });
        });
    };
};

export const getObjects = (fulltext = "", search = {}, limit = 20, offset = 0, sort = {}) => {
    const add = {};
    add.limit = limit;
    add.offset = offset;

    if(search.fields && search.fields.length) {
        add.fields = search.fields;
    } else {
        add.fields = [];
    }
    
    add.fields.push({ field: sort.field, type: "ORDER", value: sort.dir});
    
    add.kaenguruh = 'no';
    
    return (dispatch) => {
        dispatch({ type: actionTypes.SDK_OBJECT_GET_START });
        window.flow.sdkSearchObjects(fulltext, add).then((res) => {
            console.log(res);
            dispatch({ type: actionTypes.SDK_OBJECT_GET_SUCCESS, objects: res.objects.asArray(), objectsObj: res.objects.elements, count: res.count || 0 });
        }).catch(res => {
            dispatch({ type: actionTypes.SDK_OBJECT_GET_FAIL });
        });
    };
};

export const sdkSetLimit = (type, limit) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.SDK_SET_LIMIT, section: type, limit: limit });
    }
}

export const sdkSetOffset = (type, offset) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.SDK_SET_OFFSET, section: type, offset: offset });
    }
}

export const sdkSetSort = (type, sort) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.SDK_SET_SORT, section: type, sort: sort });
    }
}

export const sdkSearch = (type, fulltext, search) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.SDK_SEARCH_START });
        const fields = [];
        switch(type) {
            case "work":
                if(search.title) {
                    fields.push({ field: "title", type: "CONTAINS", value: search.title});
                }
                
                if(search.production_date_start) {
                    fields.push({ field: "production_date_start", type: "CONTAINS", value: search.production_date_start});
                }
                
                if(search.production_date_end) {
                    fields.push({ field: "production_date_end", type: "CONTAINS", value: search.production_date_end});
                }
                
                if(search.production_country) {
                    fields.push({ field: "production_country", type: "CONTAINS", value: search.production_country});
                }
                
                if(search.nfa_category) {
                    fields.push({ field: "nfa_category", type: "CONTAINS", value: search.nfa_category});
                }
                
                break;
            case "object":
                /*if(search.txt6) {
                    fields.push({ field: "txt6", type: "CONTAINS", value: search.txt6});
                }
                
                if(search.txt2) {
                    fields.push({ field: "txt2", type: "CONTAINS", value: search.txt2});
                }
                */
                if(search.object_number) {
                    fields.push({ field: "object_number", type: "CONTAINS", value: search.object_number});
                }
				if(search.title) {
                    fields.push({ field: "title", type: "CONTAINS", value: search.title});
                }
				if(search.administration_name) {
                    fields.push({ field: "administration_name", type: "CONTAINS", value: search.administration_name});
                }
				if(search.txt3) {
                    fields.push({ field: "txt3", type: "CONTAINS", value: search.txt3});
                }
				if(search.txt2) {
                    fields.push({ field: "txt2", type: "CONTAINS", value: search.txt2});
                }
				if(search.txt5) {
                    fields.push({ field: "txt5", type: "CONTAINS", value: search.txt5});
                }
				if(search.txt7) {
                    fields.push({ field: "txt7", type: "CONTAINS", value: search.txt7});
                }
				if(search.txt8) {
                    fields.push({ field: "txt8", type: "CONTAINS", value: search.txt8});
                }
                break;
            case "person":
                
                break;
        }
        
        console.log(fields);
        console.log(fulltext);
        dispatch({ 
            type: actionTypes.SDK_SEARCH_SUCCESS, 
            fulltext: { [type]: fulltext },
            search: { [type]: { search: search, fields: fields } },
            section: type
        });
    };
};

export const sdkOnSelect = (type, obj) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.SDK_ON_SELECT, section: type, obj: obj });
    }
}

